import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M21.426 8.124 4.92 3.062A1.5 1.5 0 0 0 3 4.5V18a1.5 1.5 0 0 0 1.924 1.44l7.826-2.403V18a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-2.803l2.676-.82a1.51 1.51 0 0 0 1.074-1.44V9.564a1.51 1.51 0 0 0-1.074-1.439M17.25 18h-3v-1.423l3-.92zM21 12.938h-.01l-6.74 2.07V7.492l6.74 2.07H21z"
    }, null, -1)
  ]))]))
}
export default { render: render }